<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="non?.mesuresConfidentialite"
	
	[label]="step1.mesuresConfidentialite"
	[type]="'text'"
	[rule]="'minSize_1|maxSize_300|required'"
	[errorMessage]="{'required' : 'ctr_1072'}"
	[name]="getUid() + '_SepAtt_mesuresConfidentialite'"
>
</app-form-input>
